module.exports = __webpack_public_path__ + "assets/img/2021bg.1b879e40.png";